import { render, staticRenderFns } from "./ProjectPotatoSubmissionForm.vue?vue&type=template&id=b7a1f948"
import script from "./ProjectPotatoSubmissionForm.vue?vue&type=script&lang=js"
export * from "./ProjectPotatoSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports